import Vue from 'vue'
//import VueJWT from 'vuejs-jwt'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import VueApexCharts from 'vue-apexcharts'
import VueJWT from 'vuejs-jwt'
import VModal from 'vue-js-modal'
//Vue.use(VueApexCharts)
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

import { formatThDate } from "./library/functions.js";


//Vue.component('apexchart', VueApexCharts)
Vue.use(VModal,  { dynamicDefault: { draggable: true, resizable: true } })
Vue.use(VueCookies,VueApexCharts)
Vue.filter('numFormat', numFormat(numeral));
Vue.filter('formatThDate', formatThDate);

Vue.config.productionTip = false
Vue.$cookies.config('7d')
new Vue({
  vuetify,
  router,
  store,
  VueCookies,
  VueApexCharts,
  VueJWT,
  render: h => h(App)
}).$mount('#app')
